import { render, staticRenderFns } from "./ProffesionalExperienceManagement.vue?vue&type=template&id=85e56412&scoped=true&style=font-family%3A%20'roboto'%3B&"
import script from "./ProffesionalExperienceManagement.vue?vue&type=script&lang=js&"
export * from "./ProffesionalExperienceManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProffesionalExperienceManagement.vue?vue&type=style&index=0&id=85e56412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e56412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VLayout,VPagination,VRow,VTextField})
